import React, {
  useEffect,
  useState,
} from 'react';

import {
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {
  FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';

import {
  faArrowLeft,
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';




import RecordsAccounting
  from './components/RecordsAccounting.jsx';

  import ContaAplicataLeftPanel
  from './components/ContaAplicataLeftPanel.jsx';

import {
  completeUnitCourseLesson,
  CONTA_APLICATA_COURSE_ID,
} from '../shared/unitCourseProgress';


import './ContaAplicata.css';


const ContaAplicata = () => {

  const navigate =
    useNavigate();

  const location =
    useLocation();


  /* =====================================================
     DATE PRIMITE DIN PAGINA CURSULUI
  ===================================================== */

  const {
    unitId,
    lessonId,
    unitTitle,
    lessonTitle,
  } =
    location.state || {};


  /* =====================================================
     LECTIA DIN BACKEND
  ===================================================== */

  const [
    lesson,
    setLesson,
  ] =
    useState(null);


  const [
    loading,
    setLoading,
  ] =
    useState(true);


  const [
    error,
    setError,
  ] =
    useState(null);


  /* =====================================================
     PAS CURENT
  ===================================================== */

  const [
    currentStepIndex,
    setCurrentStepIndex,
  ] =
    useState(0);


  /* =====================================================
     INCARCARE LECTIE
  ===================================================== */

  useEffect(() => {

    if (
      !unitId ||
      !lessonId
    ) {
      setLoading(false);
      return;
    }


    const loadLesson =
      async () => {

        try {

          setLoading(true);
          setError(null);


          const response =
            await fetch(
              `${process.env.REACT_APP_API_URL}/contaaplicata/${unitId}/lesson/${lessonId}`,
              {
                credentials:
                  'include',
              }
            );


          if (
            !response.ok
          ) {
            throw new Error(
              `Lectia nu a putut fi incarcata. Status: ${response.status}`
            );
          }


          const data =
            await response.json();


          console.log(
            'Lectie contabilitate aplicata:',
            data
          );


          setLesson(
            data
          );


          setCurrentStepIndex(
            0
          );

        } catch (err) {

          console.error(
            'Eroare la incarcarea lectiei:',
            err
          );


          setError(
            err.message
          );

        } finally {

          setLoading(false);

        }

      };


    loadLesson();

  }, [
    unitId,
    lessonId,
  ]);


  /* =====================================================
     PASUL CURENT
  ===================================================== */

  const totalSteps =
    lesson?.steps?.length ||
    0;


  const currentStepData =
    lesson?.steps?.[
      currentStepIndex
    ] ||
    null;


  /* =====================================================
     DOCUMENTUL LECTIEI

     Cautam factura in toti pasii.

     Poate fi definita o singura data
     si apoi reutilizata in intreaga lectie.
  ===================================================== */

const currentInvoice =
  currentStepData?.document?.invoice ||
  currentStepData?.left?.invoice ||
  lesson?.invoice ||
  null;


  /* =====================================================
     CAMP DE EVIDENTIAT PE DOCUMENT
  ===================================================== */

  const highlightField =
    currentStepData
      ?.highlightField ||
    currentStepData
      ?.document
      ?.highlightField ||
    '';


  /* =====================================================
     PROGRES
  ===================================================== */

  const progress =
    totalSteps > 0
      ? (
          (
            currentStepIndex +
            1
          ) /
          totalSteps
        ) *
        100
      : 0;


  /* =====================================================
     INAPOI
  ===================================================== */

  const handleBack = () => {

    if (
      currentStepIndex >
      0
    ) {

      setCurrentStepIndex(
        (prev) =>
          prev - 1
      );

    }

  };


  /* =====================================================
     CONTINUA
  ===================================================== */

  const handleNext = async () => {

    if (
      currentStepIndex <
      totalSteps - 1
    ) {

      setCurrentStepIndex(
        (prev) =>
          prev + 1
      );

      return;
    }


    // Aplicatia s-a terminat: o salvam inainte de a reveni la curs,
    // ca pagina cursului sa o vada deja bifata.
    await completeUnitCourseLesson(
      CONTA_APLICATA_COURSE_ID,
      unitId,
      lessonId
    );


    navigate(
      '/functionalpagelogin'
    );

  };


  /* =====================================================
     IESIRE
  ===================================================== */

  const handleExit = () => {

    navigate(
      '/functionalpagelogin'
    );

  };


  /* =====================================================
     FARA DATE NAVIGARE
  ===================================================== */

  if (
    !unitId ||
    !lessonId
  ) {

    return (

      <div className="conta-aplicata-page">

        <div className="conta-aplicata-loading">

          <p>
            Aplicatia nu a fost selectata.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>

    );

  }


  /* =====================================================
     LOADING
  ===================================================== */

  if (loading) {

    return (

      <div className="conta-aplicata-page">

        <div className="conta-aplicata-loading">

          <p>
            Se incarca aplicatia...
          </p>

        </div>

      </div>

    );

  }


  /* =====================================================
     ERROR
  ===================================================== */

  if (error) {

    return (

      <div className="conta-aplicata-page">

        <div className="conta-aplicata-loading">

          <p>
            {error}
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>

    );

  }


  /* =====================================================
     LECTIA NU EXISTA
  ===================================================== */

  if (!lesson) {

    return (

      <div className="conta-aplicata-page">

        <div className="conta-aplicata-loading">

          <p>
            Aplicatia nu a putut fi incarcata.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>

    );

  }


  /* =====================================================
     FARA PASI
  ===================================================== */

  if (!currentStepData) {

    return (

      <div className="conta-aplicata-page">

        <div className="conta-aplicata-loading">

          <p>
            Aceasta aplicatie nu are continut disponibil.
          </p>

          <button
            type="button"
            onClick={
              handleExit
            }
          >
            Inapoi la curs
          </button>

        </div>

      </div>

    );

  }


  /* =====================================================
     RENDER
  ===================================================== */

  return (

    <div className="conta-aplicata-page">


      {/* =================================================
          HEADER
      ================================================= */}

      <header className="conta-aplicata-header">


        <button
          type="button"
          className="conta-aplicata-exit"
          onClick={
            handleExit
          }
          aria-label="Inapoi la curs"
        >

          <FontAwesomeIcon
            icon={
              faArrowLeft
            }
          />

        </button>


        <div className="conta-aplicata-header-title">

          <span>

            {
              unitTitle ||
              'Contabilitate aplicata'
            }

          </span>

          <strong>

            {
              lessonTitle ||
              lesson.title
            }

          </strong>

        </div>


        <div
          className="conta-aplicata-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-valuenow={
            Math.round(
              progress
            )
          }
        >

          <div
            className="conta-aplicata-progress-fill"
            style={{
              width:
                `${progress}%`,
            }}
          />

        </div>

      </header>


      {/* =================================================
          WORKSPACE
      ================================================= */}

      <main className="conta-aplicata-workspace">


     


      

    {/* ===============================================
            STANGA - DOCUMENT
        =============================================== */}

       
<ContaAplicataLeftPanel
  step={currentStepData}
  stepIndex={currentStepIndex}
  invoice={currentInvoice}
  highlightField={highlightField}
/>


  {/* ===============================================
            DREAPTA - PROGRAM CONTABILITATE
        =============================================== */}

        <section className="conta-aplicata-program-panel">


         


          <div className="conta-aplicata-program-content">


         <RecordsAccounting
  content={currentStepData.right}
  step={currentStepData}
  lesson={lesson}
  invoice={currentInvoice}
/>


          </div>

        </section>




      </main>


      {/* =================================================
          FOOTER
      ================================================= */}

      <footer className="conta-aplicata-bottom-bar">


        <button
          type="button"
          className="conta-aplicata-nav-btn"
          onClick={
            handleBack
          }
          disabled={
            currentStepIndex ===
            0
          }
        >

          <FontAwesomeIcon
            icon={
              faChevronLeft
            }
          />

          <span>
            Inapoi
          </span>

        </button>


        <div className="conta-aplicata-step">

          {
            currentStepIndex +
            1
          }

          {' / '}

          {
            totalSteps
          }

        </div>


        <button
          type="button"
          className="
            conta-aplicata-nav-btn
            conta-aplicata-nav-btn-next
          "
          onClick={
            handleNext
          }
        >

          <span>

            {
              currentStepIndex ===
              totalSteps - 1
                ? 'Finalizeaza'
                : 'Continua'
            }

          </span>


          <FontAwesomeIcon
            icon={
              faChevronRight
            }
          />

        </button>


      </footer>


    </div>

  );

};


export default ContaAplicata;